export default __webpack_public_path__ + "static/media/rhenus-sev.f29de45b.svg";